export const blInitialValues = {
  num_bl: "",
  cod_booking: "",
  dae: "",
  formaPago: "",
  from: "",
  hs_code: "",
  info_consignee: "",
  info_notify: "",
  info_notifya: "",
  info_shipper: "",
  local_vessel: "",
  ocean_vessel: "",
  place_delivery: "",
  port_descharge: "",
  port_loading: "",
  tipo_bl: "",
  shipper_reference: "",
};

export const tipoBlOptions = [
  "ORIGINAL BILL REQUIRED AT ORIGIN",
  "ORIGINAL BILL REQUIRED AT DESTINATION",
  "SEA WAYBILL",
  "EXPRESS BILL OF LADING",
];

export const fromOptions = [
  "GUAYAQUIL, ECUADOR",
  "QUEVEDO, ECUADOR",
  "MANTA, ECUADOR",
];

export const terminoFleteOptions = ["FREIGHT PREPAID", "FREIGHT COLLECT"];

export const placeholderShipper = `Información Shipper
Ejemplo:

    BlackBox EC
    Illinworth 
    PHONE: 09123456789
    CONTACTO: Juan Pita
    jpita@blackbox.com.ec
    RUC: 1721123456001`;

export const placeholderConsignee = `Información Consignee
Ejemplo:

    BlackBox EC
    Illinworth 
    PHONE: 09123456789
    CONTACTO: Juan Pita
    jpita@blackbox.com.ec
    RUC: 1721123456001`;

export const placeholderNotify = `Información Notify
Ejemplo:

    BlackBox EC
    Illinworth 
    PHONE: 09123456789
    CONTACTO: Juan Pita
    jpita@blackbox.com.ec
    RUC: 1721123456001`;

export const placeholderMarcas = `Ejemplo:
    LAA591831
    BMB3266`;
export const placeholderDescripcionAdicional = `Descripción adicional del contenedor (Opcional)
Ejemplo:
    BALSA WOOD KILNDRIED
    GLUED UP
    430 BULTOS
    1.100 ASIENTO
    320 SALA
    1.420 UNIDADES CONTENIDAS`;
